export default {
    apiKey: "AIzaSyDLydwtZWLx8lOLIYr_LptHPK1563QWMDU",
    authDomain: "ucberkeley-7c70f.firebaseapp.com",
    apiURL: "https://us-central1-ucberkeley-7c70f.cloudfunctions.net/",
    databaseURL: "https://ucberkeley-7c70f.firebaseio.com",
    projectId: "ucberkeley-7c70f",
    storageBucket: "ucberkeley-7c70f.appspot.com",
    messagingSenderId: "40949124519",
    appId: "1:40949124519:web:92a56b544ac46da086ba82",
    measurementId: "G-YJJW702NBQ"
};
